import {
    Component,
    Host,
    h,
    Event,
    Prop,
    Watch,
} from "@stencil/core";
import type { EventEmitter } from "@stencil/core";

@Component({
    tag: "c-input-salary",
    styleUrl: "c-input-salary.scss",
})
export class CInputSalary {
    value: string;
    inputElement: HTMLInputElement;
    @Event() inputSalary: EventEmitter<string>;
    @Prop() disabled = false;
    @Prop() placeholder = "0";
    @Watch("disabled")
    watchHandler(disabled: boolean) {
        if (!disabled) {
            setTimeout(() => this.inputElement.focus(), 0);
        }
    }

    handleKeyUp(e: any) {
        // Future Task IE support
        const key = e.key;

        if (key === "Enter") {
            this.emitValue();
        }
    }

    handleKeyDown(e: any) {
        // Future Task IE support
        const key = e.key;

        const ALLOWED_KEYS = [
            "ArrowLeft",
            "ArrowRight",
            "ArrowUp",
            "ArrowDown",
            "Backspace",
            "Delete",
            "Tab",
            "Enter",
        ];
        if (ALLOWED_KEYS.includes(key)) {
            return;
        }

        // input has type=number, which means Chrome allows numbers and .,e-+, while Firefox allows all keys
        // "e" is disallowed, because it is a mathematical constant and therefore allowed by default
        const DISALLOWED_KEYS = [".", ",", "e", "-", "+"];
        if (DISALLOWED_KEYS.includes(key)) {
            e.preventDefault();
            return;
        }

        const isNumber = new RegExp(/\d/).test(key);
        if (!isNumber) {
            e.preventDefault();
        }

        const MAX_LENGTH = 5;
        if (e.target.value.length >= MAX_LENGTH) {
            e.preventDefault();
        }
    }

    handleClick() {
        this.emitValue();
    }

    emitValue() {
        if(this.inputElement.value) {
        this.inputSalary.emit(this.inputElement.value);
        this.inputElement.value = "";
        } else return;
    }

    handleSubmit(e: any) {
        e.preventDefault();
    }

    componentDidLoad() {
        if (this.disabled) {
            return;
        }
        this.inputElement.focus();
    }

    render() {
        return (
            // Class .disabled has a naming clash with BA CSS on IE and Edge,
            // on which Shadow DOM does not work. so I named it is-disabled instead
            <Host class={this.disabled ? "is-disabled" : ""}>
                <form onSubmit={(e) => this.handleSubmit(e)}>
                    <div class="input-container">
                        <input
                            type="number"
                            title="Monatsgehalt eingeben"
                            aria-label="Monatsgehalt eingeben"
                            aria-controls="cb-conversation"
                            autocomplete="off"
                            disabled={this.disabled}
                            ref={(el: HTMLInputElement) =>
                                (this.inputElement = el)
                            }
                            placeholder={this.disabled ? "" : this.placeholder}
                            step="1"
                            min="0"
                            onKeyDown={this.handleKeyDown.bind(this)}
                            onKeyUp={this.handleKeyUp.bind(this)}
                        />
                        <span class="currency-text">€/Monat</span>
                    </div>
                    <button
                        type="submit"
                        title="Nachricht absenden"
                        aria-label="Nachricht absenden"
                        disabled={this.disabled}
                        onClick={this.handleClick.bind(this)}
                    >
                        <i aria-hidden="true" class="ba-icon ba-icon-chevron-right"/>
                    </button>
                </form>
            </Host>
        );
    }
}
